// extracted by mini-css-extract-plugin
export default {"container":"Products_container__XXWJd","products":"Products_products__1vzGc","menu":"Products_menu__YYVAE","list":"Products_list__NDwDz","product":"Products_product__yIhyz"};